import "./App.css";

import { useState } from "react";
import { Dashboard } from "./Pages/Dashboard";
import { HomePage } from "./Pages/Home-Page";

function App() {
  const [isLogged, setIsLogged] = useState(false);
  const [listTransactions, setListTransactions] = useState([]);
  const [filterValue, setFilterValue] = useState("todos");
  const arrFiltered = listTransactions.filter(({ type }) =>
    filterValue === "todos" ? type !== "todos" : type === filterValue
  );

  return (
    <div className="App">
      {isLogged === false ? (
        <HomePage setIsLogged={setIsLogged} />
      ) : (
        <Dashboard
          setIsLogged={setIsLogged}
          listTransactions={listTransactions}
          setListTransactions={setListTransactions}
          arrFiltered={arrFiltered}
          setFilterValue={setFilterValue}
        />
      )}
    </div>
  );
}

export default App;
